export default __webpack_public_path__ + "static/media/img-stake-sent.81ced77b.png";